import React, { useEffect, useState, useContext, useRef } from 'react';
import { AuthContext } from "../contexts/auth";
import CalendarWeekSelect from './calendar_week_select';
import { ChevronDownIcon, ChevronUpIcon, ChevronLeftIcon, ChevronRightIcon, DocumentPlusIcon, BriefcaseIcon, FingerPrintIcon, DocumentTextIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import ComboboxMultiSelectAPI from './combobox_multiselect_autocomplete_api';
import { getTimbratureWeek } from '../services/api_timbrature'; 
import { getEmployeesWithActiveContract } from '../services/api_calendar';
import { Link } from 'wouter';
import Swal from 'sweetalert2';
import Fetching from './fetching';
import moment from 'moment';
import DayDetailsModal from './day_details_modal';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import AddGiustificativoModal from './modal_add_giustificativo';



const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))({
    '& .MuiTooltip-tooltip': {
      backgroundColor: '#a5b4fc',
      color: '#FFFFFF',
      fontSize: '0.8rem',
      fontWeight: 'bold',
    },
    '& .MuiTooltip-arrow': {
      color: '#a5b4fc',
    },
  });
  



const TimbraturaWeekTable = ({ page, pageSize, setTotalResult, totalResult, setNextPage, setPrevPage, selectedUnit }) => {
    const { loading, token, profile } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [currentWeek, setCurrentWeek] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [attendanceData, setAttendanceData] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [holidays, setHolidays] = useState([]);
    const tableContainerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [scrollTop, setScrollTop] = useState(0);
    const firstHeaderRef = useRef(null);
    const [dipendenti, setDipendenti] = useState([]);
    const [modalDetailsData, setModalDetailsData] = useState();
    const [isModalDetailsOpen, setIsModalDetailsOpen] = useState(false);
    const [showModalAddGiustificativo, setShowModalAddGiustificativo] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const controller = useRef(null);

    const isEmployee = profile.customer_type === 'employee';
    const hasManageJustificationPermission =
        profile.employee?.permissions?.includes('hr.manage_justification_ou') ||
        profile.employee?.permissions?.includes('hr.manage_justification_all');

    const hasViewShiftPermission =
        profile.employee?.permissions?.includes('hr.view_shifts_ou') ||
        profile.employee?.permissions?.includes('hr.view_shifts_all') ||
        profile.employee?.permissions?.includes('hr.manage_shifts_ou') ||
        profile.employee?.permissions?.includes('hr.manage_shifts_all');

        useEffect(() => {
            if (controller.current) {
                controller.current.abort();
                setIsLoading(false);
            }
        
            controller.current = new AbortController();
            const signal = controller.current.signal;
        
            const getData = async () => {
                if (currentWeek.length === 0) return;
                
                setIsLoading(true);
                setIsError(false);
        
                try {
                    const startDate = formatDateWeekSelected(new Date(currentWeek[0]));
                    const endDate = formatDateWeekSelected(new Date(currentWeek[currentWeek.length - 1]));
                    
                    const attendanceResponse = await getTimbratureWeek(
                        token,
                        { startDate, endDate },
                        selectedUnit?.id,
                        selectedEmployees.map((e) => e.id),
                        page,
                        pageSize,
                        signal,
                        'inoouts',
                    );
                    
                    let arrayAttendance = [];
                    if (Array.isArray(attendanceResponse.results)) {
                        arrayAttendance = attendanceResponse.results;
                    }
    
                    setNextPage(attendanceResponse.next);
                    setPrevPage(attendanceResponse.previous);
                    setTotalResult(attendanceResponse.count);
    
                    const mappedAttendanceData = arrayAttendance?.map((employee) => ({
                        ...employee,
                        days: employee.days.map((day) => ({
                            date: day.date,
                            has_justifications: isEmployee && !hasManageJustificationPermission ? [] : day.has_justifications,
                            has_active_contract: day.has_active_contract,
                            time_slots: isEmployee && !hasViewShiftPermission ? [] : day.time_slots,
                            inouts: day.inouts.map((inout) => ({
                                ...inout,
                                over_time_checkin: inout.over_time_checkin,
                                over_time_checkout: inout.over_time_checkout,
                            })),
                            typology: day.typology,
                        })),
                    }));
    
                    setAttendanceData(mappedAttendanceData);
    
                    const newDipendenti = arrayAttendance.map((employee) => ({
                        first_name: employee.first_name,
                        last_name: employee.last_name,
                        cf: employee.cf,
                        id: employee.id,
                        email_auth: employee.email_auth,
                    }));
                    setDipendenti(newDipendenti);
    
                    const holidaysData = [];
                    arrayAttendance.forEach((employee) => {
                        employee.days.forEach((day) => {
                            if (day.holidays && day.holidays.length > 0) {
                                day.holidays.forEach((holiday) => {
                                    holidaysData.push({ date: day.date, name: holiday.name });
                                });
                            }
                        });
                    });
                    setHolidays(holidaysData);
    
                    setIsLoading(false);
        
                } catch (error) {
                    console.log('ERRORE', error);
                    if (error?.response?.status === 402) {
                        setIsError(false);
                    } else if (error?.name != 'CanceledError') {
                        console.error(error);
                        setIsError(true);
                        setIsLoading(false);
                    }
                }
            };

            getData();
        
        }, [token, currentWeek, selectedUnit, selectedEmployees, page, pageSize]);
        
    

    // useEffect(() => {
    //     const controller = new AbortController();
    //     const signal = controller.signal;

    //     fetchActiveEmployees();
    //     return () => {
    //         controller.abort();
    //     }
    // }, [token, currentWeek, selectedUnit, selectedEmployees, page, pageSize]);

    useEffect(() => {
        const today = new Date();
        setCurrentWeek(getCompleteWeek(today));
    }, []);

    const getCompleteWeek = (date) => {
        const currentDayOfWeek = date.getDay();
        const mondayDiff = currentDayOfWeek === 0 ? -6 : 1 - currentDayOfWeek;
        const monday = new Date(date);
        monday.setDate(date.getDate() + mondayDiff);
        const weekDays = [monday];
        for (let i = 1; i < 7; i++) {
            const day = new Date(monday);
            day.setDate(monday.getDate() + i);
            weekDays.push(day);
        }
        return weekDays;
    };

    const handleNavigateWeek = (direction) => {
        const newMonday = new Date(currentWeek[0]);
        newMonday.setDate(newMonday.getDate() + 7 * direction);
        setCurrentWeek(getCompleteWeek(newMonday));
        setSelectedMonth(new Date(newMonday.getFullYear(), newMonday.getMonth(), 1));
    };

    const formatDateWeekSelected = (date) => {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            console.error('Invalid date provided:', date);
            return 'Invalid Date';
        }

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleSelectionChange = (newSelectedEmployees) => {
        setSelectedEmployees(newSelectedEmployees);
    };

    const handleDeselectEmployee = (employeeId) => {
        setSelectedEmployees((prevSelected) =>
            prevSelected.filter((emp) => emp.id !== employeeId)
        );
    };

    const handleResetSelection = () => {
        setSelectedEmployees([]);
    };

    useEffect(() => {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        setFirstDayOfMonth(firstDayOfMonth);

        const currentDayOfWeek = today.getDay();
        const mondayDiff = currentDayOfWeek === 0 ? -6 : 1 - currentDayOfWeek;
        const monday = new Date(today);
        monday.setDate(today.getDate() + mondayDiff);
        const weekDays = [monday];
        for (let i = 1; i < 7; i++) {
            const day = new Date(monday);
            day.setDate(monday.getDate() + i);
            weekDays.push(day);
        }
        setCurrentWeek(weekDays);
    }, []);

    const [firstDayOfMonth, setFirstDayOfMonth] = useState(new Date());
    const currentMonthName = firstDayOfMonth.toLocaleString('it-IT', { month: 'long' }).toLowerCase();

    const getWeekRange = (monday, sunday) => {
        const startDay = monday.getDate();
        const endDay = sunday.getDate();
    
        const startMonth = monday.toLocaleDateString('it-IT', { month: 'long' });
        const endMonth = sunday.toLocaleDateString('it-IT', { month: 'long' });
    
        if (startMonth !== endMonth) {
            return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
        }
    
        return `${startDay} - ${endDay} ${startMonth}`;
    };
    
    const formatDay = (date) => {
        if (!date) return "";

        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
        .toISOString().split('T')[0];

        const dayOfWeek = date.getDay();
        const formattedDate = date.toISOString().split('T')[0];

        const isHoliday = holidays.some(holiday => holiday.date === localDate);
    
        const options = { weekday: 'long', day: 'numeric' };
    
        if (isHoliday) {
            return (
                <div className="text-orange-500 font-bold">
                    {date.toLocaleDateString('it-IT', options)}
                </div>
            );
        } else if (dayOfWeek === 0) {

            return (
                <div className="text-emerald-500 font-bold">
                    {date.toLocaleDateString('it-IT', options)}
                </div>
            );
        } else {
            return (
                <div className="text-gray-600">
                    {date.toLocaleDateString('it-IT', options)}
                </div>
            );
        }
    };
    

    const handleWeekSelect = (weekDays) => {
        setCurrentWeek(weekDays);

        if (weekDays.length > 0) {
            const firstDayOfWeek = weekDays[0];
            setSelectedMonth(new Date(firstDayOfWeek.getFullYear(), firstDayOfWeek.getMonth(), 1));
        }
    };

    const [calendarVisible, setCalendarVisible] = useState(false);

    const handleSelectClick = () => {
        setCalendarVisible(!calendarVisible);
    };

    const getEmptyCellsAtStart = (firstDayOfWeek) => {
        if (firstDayOfWeek instanceof Date) {
            const startDayOfWeek = firstDayOfWeek.getDay();
            return startDayOfWeek === 0 ? 6 : startDayOfWeek - 1;
        } else {
            return 0;
        }
    };

    const getEmptyCellsAtEnd = (lastDayOfWeek) => {
        if (lastDayOfWeek instanceof Date) {
            const endDayOfWeek = lastDayOfWeek.getDay();
            return endDayOfWeek === 0 ? 0 : 7 - endDayOfWeek;
        } else {
            return 0;
        }
    };
    
    const emptyCellsAtStart = getEmptyCellsAtStart(currentWeek[0]);
    const emptyCellsAtEnd = getEmptyCellsAtEnd(currentWeek[currentWeek.length - 1]);

    const handleOpenDetailsModal = (dipendente, formattedDay) => {
        if (!dipendente) return;

        setSelectedEmployee(dipendente);
        setModalDetailsData(formattedDay);
        setIsModalDetailsOpen(true);
    };

    const handleAddGiustificativoModal = (dipendente, selectedDay, attendanceForDay) => {
        if (!dipendente) return;
        console.log('formatted day', attendanceForDay);
        
        setSelectedEmployee(dipendente);
        setSelectedDay(selectedDay);
        setModalDetailsData(attendanceForDay);
        setShowModalAddGiustificativo(true);
    };

    const handleNewJustificationRequest = () => {
        setAttendanceData((prevData) =>
            prevData.map((employee) => {
                if (employee.id !== selectedEmployee.id) return employee;
    
                const updatedDays = employee.days.map((day) => {
                    if (day.date !== selectedDay) return day;
    
                    return {
                        ...day,
                        has_justifications: true,
                    };
                });
    
                return {
                    ...employee,
                    days: updatedDays,
                };
            })
        );
    
        setShowModalAddGiustificativo(false);
    };
    
    // const formatTimbrature = (checkin, checkout, currentDate) => {
    //     const checkinDate = moment(checkin);
    //     const checkoutDate = moment(checkout);
    //     const isSameDay = checkinDate.isSame(currentDate, 'day');
      
    //     if (isSameDay) {
    //       return `${checkinDate.format('HH:mm')} - ${checkoutDate.format('HH:mm')}`;
    //     } else {
    //       return `${checkinDate.format('DD/MM/YYYY HH:mm')} - ${checkoutDate.format('DD/MM/YYYY HH:mm')}`;
    //     }
    // };

    const formatTimbrature = (inout, currentDate) => {
        const { checkin, checkout, over_time_checkin, over_time_checkout } = inout;
        const checkinDate = checkin ? moment(checkin) : null;
        const checkoutDate = checkout ? moment(checkout) : null;
    
        if (!checkinDate && !checkoutDate) {
            return 'Non presente';
        }
    
        const formattedCheckin = checkinDate
            ? checkinDate.isSame(moment(currentDate), 'day')
                ? checkinDate.format('HH:mm')
                : checkinDate.format('DD/MM/YYYY HH:mm')
            : <span className='text-gray-700'>/</span>;
    
        const formattedCheckout = checkoutDate
            ? checkoutDate.isSame(moment(currentDate), 'day')
                ? checkoutDate.format('HH:mm')
                : checkoutDate.format('DD/MM/YYYY HH:mm')
            : <span className='text-gray-800'>/</span>;
                
        const checkinColor = over_time_checkin ? 'text-red-500' : 'text-green-500';
        const checkoutColor = over_time_checkout ? 'text-red-500' : 'text-green-500';

        return (
            <span>
                <span className={checkinColor}>{formattedCheckin}</span> - 
                <span className={checkoutColor}> {formattedCheckout}</span>
            </span>
        );
    };    

    const isWeekend = (date) => {
        const dayOfWeek = new Date(date).getDay();
        return dayOfWeek === 0; // 0 = Domenica
    };

    const startDragging = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - tableContainerRef.current.offsetLeft);
        setScrollLeft(tableContainerRef.current.scrollLeft);
    };

    const stopDragging = () => {
        setIsDragging(false);
    };

    const onDrag = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - tableContainerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Velocità dello scroll
        tableContainerRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleScroll = () => {
        const container = tableContainerRef.current;
        if (container) {
            const scrollTop = container.scrollTop;
            setScrollTop(scrollTop);
        }
    };

    useEffect(() => {
        if (isDragging) {
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('mouseup', stopDragging);
        } else {
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDragging);
        }

        const container = tableContainerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
        }

        return () => {
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDragging);
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, [isDragging]);


    if(isLoading)
        return (
            <div className='w-full'>
                <Fetching />
            </div>
        );

    
    return (
        <div className='container mx-4 px-3 rounded-md'>
            <div className="grid grid-cols-1 md:grid-cols-5 mb-4 justify-center items-center">
                <div className="col-span-1 hidden md:block"></div>
                <div className="col-span-1 md:col-span-2 mb-4 items-center justify-center md:ms-5">
                    <ComboboxMultiSelectAPI
                        getData={async (query) => {
                            if (query.trim() === '') {
                            return Promise.resolve([]);
                            }

                            const page = 1;
                            const pageSize = 5;

                            try {
                            const res = await getEmployeesWithActiveContract(token, query, 'hr_active', null, page, pageSize);

                            const employeesArray = Array.isArray(res.results) ? res.results : [];
                            return employeesArray; 
                            } catch (error) {
                            console.error("Errore durante il recupero dei dati:", error);
                            return [];
                            }
                        }}
                        getDisplay={(dip) => dip.last_name && dip.first_name ? `${dip.last_name} ${dip.first_name}` : dip.cf}
                        getId={(dip) => dip.id}
                        selectedValues={selectedEmployees || selectedUnit}
                        onChange={handleSelectionChange}
                        placeholder="Cerca dipendente..."
                    />
                </div>
            </div>
            {selectedEmployees.length > 0 ? (
                <div className="mb-4">
                    <div className="flex flex-wrap gap-2 mt-2">
                        {selectedEmployees.map((employee) => (
                            <div
                                key={employee.id}
                                className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-200 text-indigo-800 text-xs font-medium cursor-pointer hover:bg-indigo-300"
                                onClick={() => handleDeselectEmployee(employee.id)}
                            >
                                {employee?.last_name && employee?.first_name
                                    ? `${employee?.last_name} ${employee?.first_name}`
                                    : employee?.cf}
                                <span className="ml-2 text-gray-600 hover:text-red-500">&times;</span>
                            </div>
                        ))}
                        <button
                            className="inline-flex items-center rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={handleResetSelection}
                        >
                            Reset selezione
                        </button>
                    </div>
                </div>
            ) : null}


            <div className='grid grid-cols-1 w-full'>
                <div
                    style={{ flex: '1 1 auto', width: 'auto' }}
                    className="py-5 px-4 border-t border-l border-r border-gray-200 text-center w-24 text-xs font-semibold text-gray-600 uppercase align-middle"
                >
                    <div className='grid  md:grid-cols-5 sm:justify-start md:justify-around grid-cols-3'>
                        <div className='col-span-1 p-2 flex align-center justify-end sm:justify-center md:justify-end me-3'>
                            <button
                                className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                                onClick={() => handleNavigateWeek(-1)}
                            >
                                <ChevronLeftIcon className='w-5 h-5 cursor-pointer' />
                            </button>
                        </div>
                        <div className='col-span-1 p-2 flex align-center md:justify-end sm:justify-center me-3'>Seleziona Settimana</div>
                        <div className='col-span-1 p-2 align-center justify-start sm:justify-center md:justify-start md:hidden block'>
                            <button
                                className='text-gray-700 font-semibold px-1 hover:bg-gray-100'
                                onClick={() => handleNavigateWeek(1)}
                            >
                                <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                            </button>
                        </div>
                        <div
                            onClick={handleSelectClick}
                            style={{ cursor: 'pointer' }}
                            className='col-span-3 md:col-span-2 border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center md:w-4/5 w-full justify-between'
                        >
                            <div>
                                {currentWeek.length > 0 && `${getWeekRange(currentWeek[0], currentWeek[currentWeek.length - 1])} / ${selectedMonth.getFullYear()}`}
                            </div>
                            {!calendarVisible ? <ChevronDownIcon className='h-4 w-4 bg-indigo-100 rounded-md' /> : <ChevronUpIcon className='h-4 w-4 bg-indigo-100 rounded-md' />}
                        </div>
                        <div className='col-span-1 p-2 align-start justify-start hidden md:block'>
                            <button
                                className='text-gray-700 font-semibold px-1 hover:bg-gray-100 flex items-start'
                                onClick={() => handleNavigateWeek(1)}
                            >
                                <ChevronRightIcon className='w-5 h-5 cursor-pointer' />
                            </button>
                        </div>
                    </div>
                    {calendarVisible &&
                        <CalendarWeekSelect
                            onWeekSelect={handleWeekSelect}
                            onCloseCalendar={handleSelectClick}
                            selectedMonth={selectedMonth}
                        />
                    }
                </div>
            </div>

            <div className="overflow-x-auto" style={{ overflowY: 'scroll', overflowX: 'auto', height: '100%' }}>
                <div
                    ref={tableContainerRef}
                    style={{
                        overflowX: 'auto',
                        overflowY: 'auto',
                        cursor: isDragging ? 'grabbing' : 'grab',
                        maxHeight: '70vh',
                        position: 'relative'
                    }}
                    onMouseDown={startDragging}
                >
                    {isError ? (
                          <div
                          className="m-4 relative block rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                          <span className="mt-2 block text-sm font-semibold text-gray-900">Errore nel caricamento dei dati</span>
                        </div>
                    ) : (
                        <table className="min-w-full border divide-y divide-gray-200">
                            <thead ref={firstHeaderRef} style={{ position: 'sticky', top: 0, zIndex: 11, background: 'white' }}>
                                <tr>
                                    <th
                                        className="text-left text-xs font-semibold text-gray-600 uppercase pl-2 w-[128px]"
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            left: 0,
                                            backgroundColor: 'white',
                                            zIndex: 50,
                                            minWidth: '128px',
                                            maxWidth: '128px',
                                            boxShadow: 'inset -1px 0 #d1d5db, inset 1px 0 #d1d5db, inset 0 -1px #d1d5db, inset 0 1px #d1d5db',
                                        }}
                                    >
                                        Giorno
                                    </th>
                                    <th
                                        className="text-left text-xs font-semibold text-gray-600 uppercase pl-2 w-[112px]"
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            left: '128px',
                                            backgroundColor: 'white',
                                            zIndex: 45,
                                            minWidth: '60px',
                                            maxWidth: '60px',
                                            boxShadow: 'inset -1px 0 #d1d5db, inset 1px 0 #d1d5db, inset 0 -1px #d1d5db, inset 0 1px #d1d5db',
                                        }}
                                    >
                                        
                                    </th>

                                    {dipendenti.map((d) => (
                                        <th
                                            key={d.id}
                                            style={{
                                                backgroundColor: 'white',
                                                minWidth: '128px',
                                                maxWidth: '128px',
                                                boxShadow: 'inset -1px 0 #d1d5db, inset 1px 0 #d1d5db, inset 0 -1px #d1d5db, inset 0 1px #d1d5db',
                                                top: 0,
                                                position: 'sticky',
                                                zIndex: 40, 
                                            }}
                                            className="text-center text-xs font-semibold text-gray-600 uppercase p-2"
                                        >
                                            <Link href={`/dipendenti/${d.cf}`} className="hover:text-indigo-700">
                                                {d.first_name ? `${d.last_name} ${d.first_name}`.slice(0, 25) : d.cf}
                                                {d.first_name && `${d.last_name} ${d.first_name}`.length > 25 ? '...' : ''}
                                            </Link>
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {currentWeek.map((day, dayIndex) => {
                                    const formattedDay = formatDateWeekSelected(day);

                                    return ['Turno', 'Timbrature', 'Giustificativi', 'Info'].map((tipo, tipoIndex) => (
                                    <tr key={`${dayIndex}-${tipoIndex}`} className={dayIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                        {tipoIndex === 0 && (
                                            <td
                                                rowSpan={4}
                                                className="sticky left-0 z-10 text-xs font-semibold text-gray-600 uppercase pl-2 bg-inherit"
                                                style={{
                                                    minWidth: '128px',
                                                    maxWidth: '128px',
                                                    boxShadow: 'inset -1px 0 #d1d5db, inset 1px 0 #d1d5db, inset 0 -1px #d1d5db, inset 0 1px #d1d5db',
                                                }}
                                            >
                                                {formatDay(day)}
                                            </td>
                                        )}

                                        {/* Colonna Dettagli */}
                                        <td
                                            className="sticky left-[128px] z-10 text-xs font-medium text-gray-700 bg-inherit"
                                            style={{
                                                minWidth: '60px',
                                                maxWidth: '60px',
                                                boxShadow: 'inset -1px 0 #d1d5db, inset 1px 0 #d1d5db, inset 0 -1px #d1d5db, inset 0 1px #d1d5db',
                                            }}
                                            >
                                                <div className="flex items-center justify-center h-full">
                                                    {tipo === 'Turno' && (
                                                    <CustomTooltip title="Turno" placement="left" arrow>
                                                        <div>
                                                        <BriefcaseIcon className="h-5 w-5 text-indigo-800" />
                                                        </div>
                                                    </CustomTooltip>
                                                    )}
                                                    {tipo === 'Timbrature' && (
                                                    <CustomTooltip title="Timbrature" placement="left" arrow>
                                                        <div>
                                                        <FingerPrintIcon className="h-5 w-5 text-indigo-800" />
                                                        </div>
                                                    </CustomTooltip>
                                                    )}
                                                    {tipo === 'Giustificativi' && (
                                                    <CustomTooltip title="Giustificativi" placement="left" arrow>
                                                        <div>
                                                        <DocumentTextIcon className="h-5 w-5 text-indigo-800" />
                                                        </div>
                                                    </CustomTooltip>
                                                    )}
                                                    {tipo === 'Info' && (
                                                    <CustomTooltip title="Info" placement="left" arrow>
                                                        <div>
                                                        <InformationCircleIcon className="h-5 w-5 text-indigo-800" />
                                                        </div>
                                                    </CustomTooltip>
                                                    )}
                                                </div>
                                            </td>

                                        {(() => {
                                            const employeesToShow = selectedEmployees.length > 0 ? selectedEmployees : dipendenti;

                                            if (!isLoading && employeesToShow.length === 0) {
                                                return (
                                                    <td className="pl-4 py-3 border-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-500 uppercase"></td>
                                                );
                                            }

                                            return employeesToShow.map((dipendente) => {
                                                const employeeAttendance = attendanceData?.find((employee) => employee.id === dipendente.id)?.days || [];
                                                const employeeData = attendanceData?.find((employee) => employee.id === dipendente.id);
                                                const attendanceForDay = employeeAttendance.find((attendance) => attendance.date === formattedDay);
                                                const hasActiveContract = attendanceForDay?.has_active_contract;
                                                const timeSlots = attendanceForDay?.time_slots || [];
                                                const timbrature = attendanceForDay?.inouts || [];
                                                const isHoliday = holidays.some((holiday) => holiday.date === formattedDay);
                                                const weekend = isWeekend(day);
                                                
                                                const canViewDetails = profile?.customer_type === 'employee'
                                                ? profile.employee?.permissions?.some((permission) =>
                                                    ['hr.view_shifts_ou', 'hr.view_shifts_all', 'hr.manage_shifts_ou', 'hr.manage_shifts_all', 'hr.view_inouts_ou', 'hr.view_inouts_all'].includes(permission)
                                                    )
                                                : true;

                                                const canManageJR = profile?.customer_type === 'employee'
                                                ? profile.employee?.permissions?.some((permission) =>
                                                    ['hr.view_shifts_ou', 'hr.view_shifts_all', 'hr.manage_justification_ou', 'hr.manage_justification_all', 'hr.manage_shifts' ].includes(permission)
                                                    )
                                                : true;
                                            
                                                const handleClick = () => {
                                                    if (!canViewDetails) {
                                                        Swal.fire({
                                                        title: 'Non hai i permessi per eseguire questa azione.',
                                                        icon: 'warning',
                                                        confirmButtonText: 'Ok',
                                                        });
                                                        return;
                                                    }
                                                    else if (!hasActiveContract) {
                                                        Swal.fire({
                                                            title: 'Contratto non attivo sul giorno selezionato',
                                                            icon: 'warning',
                                                            confirmButtonText: 'Ok',
                                                        });
                                                        return;
                                                    }
                                                    attendanceForDay && handleOpenDetailsModal(dipendente, formattedDay);
                                                };

                                                const handleAddGustificativo = () => {
                                                    if (!canManageJR) {
                                                        Swal.fire({
                                                        title: 'Non hai i permessi per eseguire questa azione.',
                                                        icon: 'warning',
                                                        confirmButtonText: 'Ok',
                                                        });
                                                        return;
                                                    }
                                                    else if (!hasActiveContract) {
                                                        Swal.fire({
                                                            title: 'Contratto non attivo sul giorno selezionato',
                                                            icon: 'warning',
                                                            confirmButtonText: 'Ok',
                                                        });
                                                        return;
                                                    }
                                                    attendanceForDay && handleAddGiustificativoModal(dipendente, formattedDay, attendanceForDay);
                                                };

                                                const cellStyles = {
                                                    position: 'relative',
                                                    ...(!hasActiveContract ? PatternInactiveEmployee() : {}),
                                                    ...(hasActiveContract && weekend ? SvgPattern() : {}),
                                                    ...(hasActiveContract && isHoliday ? SvgHoliday() : {}),
                                                    ...(hasActiveContract && isHoliday && weekend ? SvgHolidayWeekend() : {}),
                                                };

                                                if (!hasActiveContract) {
                                                    return (
                                                        <td
                                                            key={`${dipendente.id}-${dayIndex}-${tipoIndex}`}
                                                            className="align-top border-2 border-gray-200 text-center w-[128px] text-sm font-semibold uppercase p-1.5"
                                                            style={cellStyles}
                                                        >
                                                            <span className='text-transparent'>-</span>
                                                        </td>
                                                    );
                                                }

                                                return (
                                                    <td
                                                        key={`${dipendente.id}-${dayIndex}-${tipoIndex}`}
                                                        className={`align-top border-2 border-gray-200 text-center w-[128px] text-sm font-semibold uppercase ${
                                                        attendanceForDay ? 'cursor-pointer' : ''
                                                        }`}
                                                        style={cellStyles}
                                                    >
                                                        {tipo === 'Turno' && (
                                                            timeSlots.length > 0 ? (
                                                                <ul className="text-xs p-1.5">
                                                                    {timeSlots.sort((a, b) => a.start_at.localeCompare(b.start_at)).map((slot, index) => (
                                                                        <li key={index} className="flex items-center justify-center text-gray-700 normal-case text-xs">
                                                                            <div className="flex-1 text-center justify-center">
                                                                                <span>{slot.start_at} - {slot.end_at}</span>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            ) : (
                                                                <div className="flex items-center justify-center text-gray-400 normal-case text-xs p-1.5">
                                                                    <div className="flex-1 text-center justify-center">
                                                                        {attendanceForDay?.typology === 'fisso' && isHoliday ? (
                                                                            <span className="text-gray-800">Festivo</span>
                                                                        ) : (
                                                                            <span>Non presente</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}

                                                        {tipo === 'Timbrature' && (
                                                            timbrature.length > 0 ? (
                                                                <ul className="text-xs p-1.5">
                                                                    {timbrature.map((inout, index) => (
                                                                        <li key={index} className="text-gray-600 flex items-center">
                                                                            <div className="flex-1 text-center justify-center">
                                                                                <span>{formatTimbrature(inout, day)}</span>
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            ) : (
                                                                <div className="flex items-center justify-center text-gray-400 normal-case text-xs p-1.5">
                                                                    <div className="flex-1 text-center justify-center">
                                                                        <span>{moment(day).isAfter(moment(), 'day') ? <span className='text-transparent'>-</span> : 'Non presente'}</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        )}

                                                        {tipo === 'Giustificativi' && (
                                                            isEmployee && !hasManageJustificationPermission ? <span className='text-transparent'>-</span> : (
                                                                attendanceForDay?.has_justifications !== undefined ? (
                                                                    <div className="flex items-center justify-between text-xs text-gray-400 p-1.5">
                                                                        {attendanceForDay?.has_justifications ? (
                                                                            <span className="flex-1 text-center text-gray-800">SI</span>
                                                                        ) : (
                                                                            <span className="normal-case flex-1 text-center">Non presenti</span>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex items-center justify-between text-xs text-gray-400 p-1.5">
                                                                        <div className="flex-1 text-center normal-case">
                                                                            <span>Non presente</span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )
                                                        )}
                                                        {tipo === 'Info' && (
                                                            <>
                                                                <div className="flex flex-row space-x-2">
                                                                    <CustomTooltip 
                                                                        title='Visualizza dettagli' 
                                                                        placement="bottom"
                                                                        arrow
                                                                        PopperProps={{
                                                                        modifiers: [
                                                                            {
                                                                            name: 'offset',
                                                                            options: {
                                                                                offset: [0, -10], 
                                                                            },
                                                                            },
                                                                        ],
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="flex items-center justify-center w-full h-full"
                                                                            onClick={handleClick}
                                                                        >
                                                                            <div className="flex items-center justify-center rounded-md bg-white p-1 shadow-sm text-indigo-800 w-full cursor-pointer hover:bg-indigo-500 hover:text-white">
                                                                                <ManageSearchIcon style={{ fontSize: 20 }} />
                                                                            </div>
                                                                        </div>
                                                                    </CustomTooltip>
                                                                
                                                                    <CustomTooltip 
                                                                        title='Aggiungi giustificativo' 
                                                                        placement="bottom"
                                                                        arrow
                                                                        PopperProps={{
                                                                        modifiers: [
                                                                            {
                                                                            name: 'offset',
                                                                            options: {
                                                                                offset: [0, -10], 
                                                                            },
                                                                            },
                                                                        ],
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="flex items-center justify-center w-full h-full"
                                                                            onClick={handleAddGustificativo}
                                                                        >
                                                                            <div className="flex items-center justify-center rounded-md bg-white p-1 shadow-sm text-indigo-800 w-full cursor-pointer hover:bg-indigo-500 hover:text-white">
                                                                                <DocumentPlusIcon className='h-5 w-5' />
                                                                            </div>
                                                                        </div>
                                                                    </CustomTooltip>
                                                                </div>
                                                            </>
                                                        )}
                                                    </td>
                                                );
                                            });
                                        })()}
                                    </tr>
                                    ));
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

            {isModalDetailsOpen && (
                <DayDetailsModal 
                    isOpen={isModalDetailsOpen} 
                    onClose={() => setIsModalDetailsOpen(false)} 
                    formattedDay={modalDetailsData} 
                    employee={selectedEmployee} 
                />
            )}


            {showModalAddGiustificativo && (
                <AddGiustificativoModal
                    closeModalAddGiustificativi={() => setShowModalAddGiustificativo(false)}
                    dipendente={selectedEmployee}
                    formattedDay={selectedDay}
                    selectedJustification={modalDetailsData}
                    onSaveJustificationRequest={handleNewJustificationRequest}
                    // selectedUnit={selectedUnit}
                />
            )}
        </div>
    );
};

export default TimbraturaWeekTable;


const SvgHoliday = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23fed7aa' fill-opacity='0.3'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};


const SvgHolidayWeekend = () => {
    return {
        backgroundColor: '#feead2',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.3'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};

const SvgPattern = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='48' height='32' viewBox='0 0 48 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2322c55e' fill-opacity='0.1'%3E%3Cpath d='M27 32c0-3.314 2.686-6 6-6 5.523 0 10-4.477 10-10S38.523 6 33 6c-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 6.627 0 12 5.373 12 12s-5.373 12-12 12c-2.21 0-4 1.79-4 4h-2zm-6 0c0-3.314-2.686-6-6-6-5.523 0-10-4.477-10-10S9.477 6 15 6c3.314 0 6-2.686 6-6h-2c0 2.21-1.79 4-4 4C8.373 4 3 9.373 3 16s5.373 12 12 12c2.21 0 4 1.79 4 4h2z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};

const PatternInactiveEmployee = () => {
    return {
        backgroundColor: '#ffffff',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%234f46e5' fill-opacity='0.3' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
    };
};
